import PropTypes from "prop-types";

export const ProteinAtlasType = PropTypes.shape({
  version: PropTypes.string,
  general_info: PropTypes.shape({
    biological_process: PropTypes.string,
    cancer_type: PropTypes.arrayOf(PropTypes.string),
    disease_involvement: PropTypes.string,
    hpa_evidence: PropTypes.string,
    molecular_function: PropTypes.string,
    normalized_disease: PropTypes.arrayOf(PropTypes.string),
    protein_class: PropTypes.string,
    rna_cancer_distribution: PropTypes.string,
    rna_cancer_specificity: PropTypes.string,
    rna_cancer_specificity_score: PropTypes.string,
    rna_specific_fpkm: PropTypes.string,
    uniprot_id: PropTypes.string,
  }),
  pathology_info: PropTypes.arrayOf(
    PropTypes.shape({
      cancer_name: PropTypes.string,
      high_risk: PropTypes.string,
      low_risk: PropTypes.string,
      medium_risk: PropTypes.string,
      not_detected: PropTypes.string,
      normalized_disease: PropTypes.string,
    })
  ),
  tissue_info: PropTypes.arrayOf(
    PropTypes.shape({
      cell_type: PropTypes.string,
      level: PropTypes.string,
      reliability: PropTypes.string,
      tissue_type: PropTypes.string,
    })
  ),
});
